'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var USD = exports.USD = 'USD';
var EUR = exports.EUR = 'EUR';
var GBP = exports.GBP = 'GBP';
var AUD = exports.AUD = 'AUD';
var JPY = exports.JPY = 'JPY';
var SGD = exports.SGD = 'SGD';
var COP = exports.COP = 'COP';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/CurrencyCodes.js
// module id = 108
// module chunks = 3 4 5